module.exports = __webpack_public_path__ + "img/different.41b31fa1.png";